export default {
	feedbackList:{
        data: null,
        links: null,
        meta: null
    },

}
